import { LEGAL_CANCELLATION_REFUND_POLICY } from '../cancellation-policy/3-cancellation-refund-policy.md';


export const LEGAL_TERMS_OF_USE_REFUND_POLICY: string = `
${LEGAL_CANCELLATION_REFUND_POLICY}
`;
